// src/supabaseConfig.js
import { createClient } from '@supabase/supabase-js';

// Access environment variables
// Hardcoded for reliability during local testing - revert to process.env before prod if strictly required
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://kdcfypmsjvbfedqsvctw.supabase.co";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtkY2Z5cG1zanZiZmVkcXN2Y3R3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3NjIwMjgsImV4cCI6MjA4NTMzODAyOH0.E_3MoV19KmyuA0_iepwpLwegSVtl5geomua1XlgLitI";

let supabase;

try {
    if (!supabaseUrl || !supabaseAnonKey) {
        console.error('Supabase variables are missing! Check your .env file or Vercel settings.');
        // Fallback or throw controlled error to avoid crash during import
        throw new Error('Supabase credentials missing');
    }
    supabase = createClient(supabaseUrl, supabaseAnonKey);
} catch (error) {
    console.error("Supabase initialization failed:", error);
    // Create a mock client or null to prevent app crash at startup
    // This allows the app to render and show a proper error UI instead of blank white screen
    supabase = {
        auth: {
            getSession: () => Promise.resolve({ data: { session: null } }),
            onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => { } } } }),
            signUp: () => Promise.reject(new Error("Supabase keys missing! Restart terminal.")),
            signInWithPassword: () => Promise.reject(new Error("Supabase keys missing! Restart terminal.")),
            signOut: () => Promise.resolve({ error: null }),
        },
        from: () => ({ select: () => ({ eq: () => ({ single: () => Promise.resolve({ error: 'Supabase not configured' }) }) }) })
    };
}

export { supabase };
export default supabase;
